export const NAME = 'mea';

/**
 * Here goes the actionTypes
 */

export const REQUEST_MEAS = 'REQUEST_MEAS';
export const RECEIVE_MEAS = 'RECEIVE_MEAS';
export const FAILURE_MEAS = 'FAILURE_MEAS';

export const SELECTION_MOMENT_MEA_TYPE = 2;
export const FICHE_MARCHAND = 4;
export const CAROUSEL_MEA_TYPE = 10;
export const ONLINE_OFFER = 14;
export const BANNIERE_ANIMATION = 49;
export const BOOSTED_OFFER_MEA_TYPE = 60;



// WEBPACK FOOTER //
// ./src/services/mea/constants.js